<template><div><h1 id="korrespondenz" tabindex="-1"><a class="header-anchor" href="#korrespondenz"><span>Korrespondenz</span></a></h1>
<p>Korrespondenz — Erfassen von Korrespondenzen bei Personen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Definiert die Details zur Produktion einer konkreten Korrespondenz bei einer Person.</p>
<p>Pfad: <code v-pre>Personen → Personen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Korrespondenzart</dt>
<dd>Kurzbezeichnung der <RouteLink to="/referenz/refs/ft.refdata.tblkorart.html">Korrespondenzart</RouteLink></dd>
<dt>Korrespondenztyp</dt>
<dd>Korrespondenztyp, nur Anzeige</dd>
<dt>Kanal</dt>
<dd>Kanal, mit welchem die Korrespondenz geschickt werden soll.</dd>
<dt>Bezeichnung</dt>
<dd>Korrespondenzbezeichnung, nur Anzeige</dd>
<dt>Adresse</dt>
<dd>Wahl einer bestimmten (alternativen) Adresse für den gewählten Kanal.</dd>
<dt>Versand</dt>
<dd>Datum des gewünschten Versands. Standard Tagesdatum, kann mit späterem Datum überschrieben werden.</dd>
<dt>Aufbereitung</dt>
<dd>mit Batchjob oder sofort.</dd>
<dt>Status</dt>
<dd>Status der Verarbeitung. Die folgenden Stati sind implementiert:
<table>
<thead>
<tr>
<th>Status</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>1</td>
<td>erfasst</td>
</tr>
<tr>
<td>3</td>
<td>verarbeitet</td>
</tr>
</tbody>
</table>
</dd>
<dt>A</dt>
<dd>Ein Icon in Form einer Büroklammer zeigt an, dass zu dieser Korrespondenz mindestens 1 Attachment verknüpft ist.</dd>
<dt>I-Ereignis1</dt>
<dd>Anzeige, evtl. auch editierbares Initialereignis</dd>
<dt>Betrag1</dt>
<dd>Betrag zum I-Ereignis1 (kann z.B. für ESR-Druck mit Betrag verwendet werden)</dd>
<dt>Währung1</dt>
<dd>(Ohne Bezeichnung, rechts von Betrag1), Default CHF</dd>
<dt>I-Ereignis2</dt>
<dd>Anzeige, evtl. auch editierbares, zweites Initialereignis</dd>
<dt>Betrag2</dt>
<dd>Betrag zum I-Ereignis2 (kann z.B. für ESR-Druck mit Betrag verwendet werden)</dd>
<dt>Währung2</dt>
<dd>(Ohne Bezeichnung, rechts von Betrag2), Default CHF</dd>
<dt>R-Ereignis</dt>
<dd>Anzeige Response-Ereignis</dd>
<dt>Text1</dt>
<dd>freies Textfeld, 255 Zeichen, Beschriftung und Vorschlagswert gemäss Eintrag in Tabelle Korrespondenzarten</dd>
<dt>Text2</dt>
<dd>freies Textfeld, 255 Zeichen, Beschriftung und Vorschlagswert gemäss Eintrag in Tabelle Korrespondenzarten</dd>
<dt>Zahl1</dt>
<dd>freies numerisches Feld, Beschriftung und Vorschlagswert gemäss Eintrag in Tabelle Korrespondenzarten</dd>
<dt>Zahl2</dt>
<dd>freies numerisches Feld, Beschriftung und Vorschlagswert gemäss Eintrag in Tabelle Korrespondenzarten</dd>
<dt>Datum1</dt>
<dd>freies Datumsfeld, Beschriftung und Vorschlagswert gemäss Eintrag in Tabelle Korrespondenzarten</dd>
<dt>Versanddatum</dt>
<dd>Datum der effektiven Verarbeitung (Batchjob, intern</dd>
<dt>Job</dt>
<dd>Nummer des Batchjobs, wenn mehrere am gleichen Datum, wird intern vergeben</dd>
<dt>Korrespondenznummer</dt>
<dd>als eindeutige Identifikation, intern vergeben</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Standardfunktionalität</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/customer/korrespondenz.html">Korrspondenz</RouteLink></p>
</div></template>


